import { ReleaseStatistics } from '../types';

export const FETCH_RELEASE_STATS_SUCCESS = 'FETCH_RELEASE_STATS_SUCCESS';

export interface ReleaseStatsHistoryResponse {
    statistics: ReleaseStatistics[];
    releaseId?: string;
    appId: string;
    orgId: string;
}

export interface FetchReleaseStatsHistorySuccessAction {
    type: typeof FETCH_RELEASE_STATS_SUCCESS;
    payload: ReleaseStatsHistoryResponse;
}

export const fetchReleaseStatsHistorySuccess: (
    payload: ReleaseStatsHistoryResponse,
) => FetchReleaseStatsHistorySuccessAction = (payload) => {
    return {
        type: FETCH_RELEASE_STATS_SUCCESS,
        payload,
    };
};
